import React, { Component } from 'react';
import { connect } from 'react-redux';

import HotelAmenity from './HotelAmenity/HotelAmenity';
import HotelAllAmenities from './HotelAllAmenities/HotelAllAmenities';
import HotelReview from './HotelReview/HotelReview';
import HotelNearby from './HotelNearby/HotelNearby';
import HotelAbout from './HotelAbout/HotelAbout';
import HotelFAQ from './HotelFAQ/HotelFAQ';
// import HotelMap from './HotelMap/HotelMap';
import HotelHeader from './HotelHeader/HotelHeader';
import HotelPhotos from './HotelPhotos/HotelPhotos';
import HotelRoomPreferences from './HotelRoomPreferences/HotelRoomPreferences';

import HeadingH2 from '../UI/Headings/HeadingH2/HeadingH2';

import Button from '../../components/UI/Button/Button';

import { Link, Element, animateScroll as scroll, scroller } from 'react-scroll';

import Spinner from '../UI/Spinner/Spinner';
import Loader from '../UI/Loader/Loader';

import classes from './HotelDetail.scss';

import * as hotelActions from '../../store/actions/index';

function scrollToTop() {
    scroll.scrollToTop();
}

class HotelDetail extends Component {
    componentWillMount() {
        this.props.onGetHotelDetails(this.props.location.search);
    }

    scrollToRoomPreference = () => {
        scroller.scrollTo('section-3', {
            duration: 1000,
            delay: 0,
            smooth: 'easeInOutQuart'
        })
    }

    render() {
        let hotelDetails = (
            <div>
                <Spinner />
                <Loader type='hotel' />
            </div>
        );

        if(!this.props.detailLoading) {
            console.log("Reched in details");
            hotelDetails = (
                <React.Fragment>
                    <div className={`u-flex f-row`}>
                        <article className={classes.Navigation}>
                            <ul className={`pt-6`}>
                                <li className={classes.NavigationItem}><Link to='section-1' className={classes.NavigationItemLink} activeClass={classes.NavigationItemLinkActive} spy={true} smooth={true} offset={-80} duration={450}>Overview</Link></li>
                                <li className={classes.NavigationItem}><Link to='section-2' className={classes.NavigationItemLink} activeClass={classes.NavigationItemLinkActive} spy={true} smooth={true} offset={-80} duration={450}>Review &amp; Analysis</Link></li>
                                <li className={classes.NavigationItem}><Link to='section-3' className={classes.NavigationItemLink} activeClass={classes.NavigationItemLinkActive} spy={true} smooth={true} offset={-80} duration={450}>Rooms</Link></li>
                                <li className={classes.NavigationItem}><Link to='section-4' className={classes.NavigationItemLink} activeClass={classes.NavigationItemLinkActive} spy={true} smooth={true} offset={-80} duration={450}>Photos</Link></li>
                                <li className={classes.NavigationItem}><Link to='section-5' className={classes.NavigationItemLink} activeClass={classes.NavigationItemLinkActive} spy={true} smooth={true} offset={-80} duration={450}>Map View</Link></li>
                                <li className={classes.NavigationItem}><Link to='section-6' className={classes.NavigationItemLink} activeClass={classes.NavigationItemLinkActive} spy={true} smooth={true} offset={-80} duration={450}>Near Landmark</Link></li>
                                <li className={classes.NavigationItem}><Link to='section-7' className={classes.NavigationItemLink} activeClass={classes.NavigationItemLinkActive} spy={true} smooth={true} offset={-80} duration={450}>About Hotel</Link></li>
                                <li className={classes.NavigationItem}><Link to='section-8' className={classes.NavigationItemLink} activeClass={classes.NavigationItemLinkActive} spy={true} smooth={true} offset={-80} duration={450}>Hotel Amenities</Link></li>
                                <li className={classes.NavigationItem}><Link to='section-9' className={classes.NavigationItemLink} activeClass={classes.NavigationItemLinkActive} spy={true} smooth={true} offset={-80} duration={450}>Hotels FAQ's</Link></li>
                            </ul>
                        </article> 
                        <div className={`${classes.Wrapper} u-width100Percent u-height100Percent`}>
                            <div className={`${classes.Container} mx-auto`}>
                                <Element name='section-1' className={`mb-6`}>
                                    <HotelHeader scrollClicked={this.scrollToRoomPreference}/>
                                    <div>
                                        <HotelAmenity/>
                                    </div>
                                </Element>
                                <div className={`phone-pl-3 phone-pr-3`}>
                                    <Element name='section-2'>
                                        <div className={`mb-10 phone-mb-4`}>
                                            <div className={`u-flex justify-content-between`}>
                                                <div className={classes.BoxOne}>
                                                    <HotelReview/>
                                                </div>
                                                {/* <div className={classes.BoxTwo}></div> */}
                                            </div>
                                        </div>
                                    </Element>
                                    <Element name='section-3'>
                                        <div className={`mb-20`}>
                                            <div className={`u-flex justify-content-between mb-6`}>
                                                <HeadingH2 size={16} weight="Medium" color="Dark">Select Room Preferences</HeadingH2>
                                            </div>
                                            <HotelRoomPreferences />
                                        </div>
                                    </Element>
                                    <Element name='section-4'>
                                        <div className={`mb-20 phone-mb-6`}>
                                            <div className={`u-flex justify-content-between mb-6 phone-mb-3`}>
                                                <HeadingH2 size={16} weight="Medium" color="Dark">Explore Hotel Photos</HeadingH2>
                                            </div>
                                            <HotelPhotos/>
                                        </div>
                                    </Element>
                                    {/* <Element name='section-5'>
                                        <div className={`mb-20`}>
                                            <div className={`u-flex justify-content-between mb-6`}>
                                                <HeadingH2 size={16} weight="Medium" color="Dark">Map View &amp; Surrounding</HeadingH2>
                                            </div> */}
                                            {/* <HotelMap/> */}
                                        {/* </div>
                                    </Element> */}
                                    <Element name='section-6'>
                                        <div className={`mb-20 phone-mb-6`}>
                                            <div className={`u-flex justify-content-between mb-6 phone-mb-3`}>
                                                <HeadingH2 size={16} weight="Medium" color="Dark">Nearby Landmarks</HeadingH2>
                                            </div>
                                            <HotelNearby/>
                                        </div>
                                    </Element>
                                    <Element name='section-7'>
                                        <div className={`mb-20 phone-mb-6`}>
                                            <div className={`u-flex justify-content-between mb-6 phone-mb-3`}>
                                                <HeadingH2 size={16} weight="Medium" color="Dark">About {this.props.detailName}</HeadingH2>
                                            </div>
                                            <HotelAbout  />
                                        </div>
                                    </Element>
                                    <Element name='section-8'>
                                        <div className={`mb-20 phone-mb-6`}>
                                            <div className={`u-flex justify-content-between mb-6 phone-mb-3`}>
                                                <HeadingH2 size={16} weight="Medium" color="Dark">Hotel Amenities</HeadingH2>
                                            </div>
                                            <HotelAllAmenities  />
                                        </div>
                                    </Element>
                                    <Element name='section-9'>
                                        <div className={`mb-20 phone-mb-6`}>
                                            <div className={`u-flex justify-content-between mb-6 phone-mb-3`}>
                                                <HeadingH2 size={16} weight="Medium" color="Dark">Frequently Asked Questions</HeadingH2>
                                            </div>
                                            <HotelFAQ/>
                                        </div>
                                    </Element>
                                </div>
                                <div className={`u-flex justify-content-center`}>
                                    <Button theme='Primary' type='ToTop' onClick={scrollToTop}>Back to Top</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {hotelDetails}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        detailLoading: state.hotels.detailLoading,
        detailName: state.hotels.detailName
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetHotelDetails: (hotelSearchParams) => dispatch(hotelActions.getHotelDetails(hotelSearchParams))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HotelDetail);


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelDetail.js